import * as React from "react"
import Layout from "../../components/layout/layout";

import autocovers from "../../images/products/pack/autocovers.jpg"
import dcut from "../../images/products/pack/dcut.jpg"
import garment from "../../images/products/pack/garmentcovers.jpg"
import ricebags from "../../images/products/pack/ricebags.jpg"
import stictched from "../../images/products/pack/stitched.jpg"
import wcut from "../../images/products/pack/wcut.jpg"

const ShopTechPage = () => {
    return (
        <Layout pageName={"Pack Tech"}>
            <div className="container justify-content-center align-items-center">
                <p
                    data-sal="fade"
                    data-sal-delay="100"
                    data-sal-easing="easeInExpo"
                    className="pb-10 lead fs-23 my-3"
                >
                    <i className="text-orange bi bi-arrow-right-short"/>
                    Texbond produces fifteen tons of various types of laminated and non - laminated bags on a daily
                    basis. Also in
                    house printing machine for multicolour image printing, automatic screen printing on rolls and
                    flexographic
                    printing is value addition to our customers. Standard sizes are available and customized sizes can
                    be made on
                    request.
                </p>
                <div className="pb-15 grid grid-view text-center">
                    <div className="row gx-md-8 gy-10 gy-md-13">
                        <div className="col-md-6 col-lg-4 pt-6 d-flex align-items-stretch">
                            <div className="lift card">
                                <figure className="card-img-top border-bottom">
                                    <img className="img-fluid" src={wcut} alt=""/>
                                </figure>
                                <div className="card-body px-6 py-5">
                                    <h4 className="mb-3">
                                        W-cut / T-shirt bags
                                    </h4>
                                    <ul className="icon-list bullet-orange">
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                20 - 80 GSM
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                White and Coloured
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Plain and Printed
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Size Range : 10” x 13”, 11” x 14”, 13” x 16”, 16” x 20”, 17” x 23”, 20” x 22”,20” x 24”</span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Standard / Customised packing available
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 pt-6 d-flex align-items-stretch">
                            <div className="lift card">
                                <figure className="card-img-top border-bottom">
                                    <img className="img-fluid" src={dcut} alt=""/>
                                </figure>
                                <div className="card-body px-6 py-5">
                                    <h4 className="mb-3">
                                        D-cut / D-punch
                                    </h4>
                                    <ul className="icon-list bullet-orange">
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                20 – 80 GSM
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                White and Coloured
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Plain and Printed
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Size Range : 9” x 12”, 8” x 10”, 10” x 13”, 12” x 16”, 14” x 19”,16” x 20”
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Standard / Customised packing available
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 pt-6 d-flex align-items-stretch">
                            <div className="lift card">
                                <figure className="card-img-top border-bottom">
                                    <img className="img-fluid" src={stictched} alt=""/>
                                </figure>
                                <div className="card-body px-6 py-5">
                                    <h4 className="mb-3">
                                        Stitched
                                    </h4>
                                    <ul className="icon-list bullet-orange">
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                For heavy weight carrying
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Capacity up to 20 kgs
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Custom design
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Printed &amp; plain
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Laminated
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Standard / Customised packing available
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 pt-6 d-flex align-items-stretch">
                            <div className="lift card">
                                <figure className="card-img-top border-bottom">
                                    <img className="img-fluid" src={ricebags} alt=""/>
                                </figure>
                                <div className="card-body px-6 py-5">
                                    <h4 className="mb-3">
                                        Rice Bags
                                    </h4>
                                    <ul className="icon-list bullet-orange">
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                5 kg, 10 kg, 25 kg
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Food grade
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Safe, Non-toxic
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Standard / Customised packing available
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 pt-6 d-flex align-items-stretch">
                            <div className="lift card">
                                <figure className="card-img-top border-bottom">
                                    <img className="img-fluid" src={autocovers} alt=""/>
                                </figure>
                                <div className="card-body px-6 py-5">
                                    <h4 className="mb-3">
                                        Automotive Covers
                                    </h4>
                                    <ul className="icon-list bullet-orange">
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                For cars, bikes, ATVs, lawn movers etc...
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Strong &amp; durable
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Water proof
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Standard / Customised packing available
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 pt-6 d-flex align-items-stretch">
                            <div className="lift card">
                                <figure className="card-img-top border-bottom">
                                    <img className="img-fluid" src={garment} alt=""/>
                                </figure>
                                <div className="card-body px-6 py-5">
                                    <h4 className="mb-3">
                                        Garment / Suite Covers
                                    </h4>
                                    <ul className="icon-list bullet-orange">
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Perfect for hanging clothes, suits, dresses, and more
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                24" x 3" x 54"
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Keeps clothing protected during travel or long term storage
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default ShopTechPage